import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";
import { verifyTFA } from "../services/authservices"; // Import the new verifyTFA function
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import i18n from "../translate/i18n";

function TfaLogin() {
  const [tfaCode, setTfaCode] = useState("");
  const [errorstatus, seterrorstatus] = useState(false);
  const navigate = useNavigate();
  const { user, login } = useContext(UserContext);
  const [toastVisible, setToastVisible] = useState(false);
  const [buttonLoader, setbuttonLoader] = useState(false);
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  const handleTfaSubmit = async (e) => {
    try {
      e.preventDefault();
      seterrorstatus(true);
      setbuttonLoader(true);
      const Useremail = localStorage.getItem("useremail");
      if (tfaCode) {
        const response = await verifyTFA(Useremail, tfaCode);
        if (response.status) {
          login(response.token);
          showSuccessToast("Login successful!");
          // setTimeout(() => {
          navigate("/home");
          // }, 2000); // 2 seconds delay
        } else {
          showerrorToast(
            <div className="toast-ml">
              <h4 className="toast-title">Error!</h4>
              <p className="toast-message">{response.Message}</p>
              {/* <p className="toast-message">Invalid 2FA code. Please try again.</p> */}
            </div>
          );
        }
      }
      setbuttonLoader(false);
    } catch (error) {
      console.error("Error during 2FA verification:", error);
      // showerrorToast(
      //   <div className="toast-ml">
      //   <h4 className="toast-title">Error!</h4>
      //   <p className="toast-message">An error occurred during 2FA verification. Please try again.</p>
      // </div>
      //   );
    }
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };

  const showerrorToast = (message) => {
    toast.dismiss();
    toast.error(message);
  };

  return (
    <div>
      <div className="row register_main container-fluid">
        <div className="col-lg-6">
          <div className="d-flex flex-column mb-5">
            <div className="register_head_logo">
              <Link to="/">
                <img
                  src={require("../assests/Logo.webp")}
                  alt="Logo"
                  className="register_logo cursor-pointer"
                />
              </Link>
            </div>
            <div className="register_left_main mt-4">
              <div className="hero_center">
                <div className="register_form">
                  <span className="register_head_sign">{t("2FA")}</span>{" "}
                  {/* Add form submission handler */}
                  <div className="register_inner_main">
                    <div className="getting_card_content w-100">
                      <div className="register_inner_submain w-100">
                        <div className="reg_inner_small">
                          <span className="register_spans">{t("2FACode")}</span>
                          <input
                            type="text"
                            placeholder={t("EnterThe2FACode")}
                            className="reg_input"
                            value={tfaCode}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value) && value.length <= 6) {
                                setTfaCode(value);
                              }
                            }}
                          />
                          {errorstatus == true ? (
                            tfaCode == null ||
                            tfaCode == undefined ||
                            tfaCode == "" ? (
                              <span className="error">
                                {t("TfaIsRequired")}
                              </span>
                            ) : tfaCode.length < 6 ? (
                              <span className="error">{t("InvalidTfa")}</span>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="getting_card_content">
                      {" "}
                      {/* Change to button element */}
                      {buttonLoader == true ? (
                        <button type="submit" className="reg_btn">
                          <span className="hero_invest">{t("loading")}</span>{" "}
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="reg_btn"
                          onClick={handleTfaSubmit}
                        >
                          {" "}
                          <span className="hero_invest">{t("Submit")}</span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                {/* <span className="reg_bottom_span">
                  <Link to="/">
                    <span className="reg_check_span">Back To Login</span>
                  </Link>
                </span> */}
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 tfa_right_main">
          <div className="login_right">
            <div className="footer_links_div">
              <span className="register_head">{t("EnterYour2FACode")}</span>
              <span className="register_subhead">
                {t("ToSecureYourAccount")} <br />{" "}
                {t("HaveReceivedInGoogleAuthenticator")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TfaLogin;
